<template>
    <div class="min-h-screen bg-gray-50 py-12">
      <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Header -->
        <div class="mb-10">
          <h1 class="text-3xl font-bold text-gray-900">Dodaj nowe urządzenie</h1>
        </div>
        <!-- Form -->
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <form @submit.prevent="handleSubmit" class="p-6">
            <!-- Device Info Section -->
            <div class="mb-8">
              <h2 class="text-lg font-medium text-gray-900 mb-4">Informacje o urządzeniu</h2>
              <div class="space-y-4">
                <div class="grid gap-4 md:grid-cols-2">
                  <div>
                    <label for="name" class="block text-sm font-medium text-gray-700 mb-1">
                      Nazwa urządzenia <span class="text-red-500">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      v-model="deviceName"
                      required
                      class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                      placeholder="np. Urządzenie w biurze"
                    />
                    <div class="mt-1 text-xs text-gray-500">Wymagane tylko nazwa urządzenia. Możesz też zeskanować QR, aby uzupełnić nazwę.</div>
                  </div>

                  <div class="space-y-3">
                    <button
                      type="button"
                      @click="toggleScanner"
                      class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      {{ scanActive ? 'Zatrzymaj skanowanie' : 'Skanuj QR' }}
                    </button>
                    <p class="text-sm text-gray-500">
                      Skanuj kod QR, aby automatycznie wypełnić nazwę urządzenia.
                    </p>
                    <p v-if="scannedValue" class="text-sm text-green-700">Zeskanowano: {{ scannedValue }}</p>
                    <p v-if="scanError" class="text-sm text-red-600">{{ scanError }}</p>
                  </div>
                </div>

                <div v-if="scanActive" class="rounded-lg overflow-hidden bg-gray-900/5 border border-gray-200">
                  <video ref="videoRef" playsinline class="w-full h-72 object-cover"></video>
                </div>
              </div>
            </div>
            <!-- Location Section -->
            <div class="mb-8">
              <h2 class="text-lg font-medium text-gray-900 mb-4">Lokalizacja urządzenia</h2>
              <div class="space-y-6">
                <!-- Address Input -->
                <div>
                  <label for="address" class="block text-sm font-medium text-gray-700 mb-1">
                    Adres <span class="text-red-500">*</span>
                  </label>
                  <div class="mt-1">
                    <input
                      id="address"
                      type="text"
                      v-model="address"
                      required
                      class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                      placeholder="ul. Przykładowa 123, 00-000 Warszawa"
                      @input="searchAddress"
                    />
                    <ul
                    v-if="locationsData.length > 0 && address.length > 3"
                    class="absolute z-10 w-full bg-white border rounded shadow mt-1 w-md" style="z-index: 999999!important;"
                  >
                    <li
                      v-for="(suggestion, index) in locationsData"
                      :key="index"
                      class="p-2 hover:bg-gray-100 cursor-pointer"
                      @click="selectSuggestion(suggestion)"
                    >
                      {{ suggestion.display_name }}
                    </li>
                  </ul>
                    <div class="mt-1 text-xs text-gray-500">
                      Wprowadź adres, aby znaleźć lokalizację urządzenia.
                    </div>
                  </div>
                </div>
                
                <!-- Map and Coordinates -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <!-- Map -->
                  <div class="md:col-span-2 relative">
                    <ClientOnly>
                        <Map @centerChange="handleCenterChange" :currentCenter="[parseFloat(latitude), parseFloat(longitude)]"></Map>
                      </ClientOnly>
                    <!-- Center Pin (fixed) -->
                    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1000] pointer-events-none">
                      <MapPinIcon class="h-8 w-8 text-primary" />
                    </div>
                    
                    <!-- Map Instructions -->
                    <div class="absolute bottom-2 left-2 right-2 bg-white/80 backdrop-blur-sm p-2 rounded text-xs text-gray-700">
                      Przesuń mapę, aby ustawić pinezkę w odpowiednim miejscu. Pinezka zawsze znajduje się na środku mapy.
                    </div>
                  </div>
                  
                  <!-- Coordinates -->
                  <div class="space-y-4">
                    <div>
                      <label for="latitude" class="block text-sm font-medium text-gray-700 mb-1">
                        Szerokość geograficzna
                      </label>
                      <input
                        id="latitude"
                        type="text"
                        v-model="latitude"
                        
                        class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-50 sm:text-sm"
                      />
                    </div>
                    <div>
                      <label for="longitude" class="block text-sm font-medium text-gray-700 mb-1">
                        Długość geograficzna
                      </label>
                      <input
                        id="longitude"
                        type="text"
                        v-model="longitude"
                        
                        class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-50 sm:text-sm"
                      />
                    </div>
                    <button
                      type="button"
                      @click="useCurrentLocation"
                      class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary bg-primary/10 hover:bg-primary/20"
                    >
                      <MapIcon class="mr-2 h-4 w-4" />
                      Użyj mojej lokalizacji
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Form Actions -->
            <div class="flex items-center justify-between pt-4 border-t border-gray-200">
              <a
                href="/"
                class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                <ArrowLeftIcon class="mr-2 h-4 w-4" />
                Powrót
              </a>
              <div class="flex space-x-3">
                <button
                  type="submit"
                  :disabled="isSubmitting"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <Loader2Icon v-if="isSubmitting" class="mr-2 h-4 w-4 animate-spin" />
                  <CheckIcon v-else class="mr-2 h-4 w-4" />
                  {{ isSubmitting ? 'Dodawanie...' : 'Dodaj urządzenie' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue';
  import { MapPinIcon, MapIcon, ArrowLeftIcon, CheckIcon, Loader2Icon } from 'lucide-vue-next';
  import { useLocationStore } from './../stores/locations';
  import { useDeviceStore } from './../stores/devices';
  const toast = useToast();
  
  definePageMeta({
    middleware: 'auth'
  })
  
  const deviceName = ref('');
  const address = ref('');
  const latitude = ref('');
  const longitude = ref('');
  const scanError = ref('');
  const scannedValue = ref('');
  const scanActive = ref(false);
  const isSubmitting = ref(false);
  const mediaStream = ref<MediaStream | null>(null);
  const scannerInterval = ref<number | null>(null);
  const videoRef = ref<HTMLVideoElement | null>(null);
  const locationsData = ref<LocationSuggestion[]>([]);

  const setDeviceNameFromScan = (value: string) => {
    const parsed = value.trim();
    scannedValue.value = parsed;
    deviceName.value = parsed;
  };
  
  const searchAddress = async () => {
    locationsData.value = await useLocationStore().getLocations(address.value);
  };
  
  const getAddress = async (lat: number, lon: number) => {
    const location = await useLocationStore().getAddr(lat, lon);
    if (location) {
      address.value = location;
    }
  };
  
  const selectSuggestion = async (suggestion: { display_name: string; lat: number; lon: number; }) => {
    address.value = suggestion.display_name;
    latitude.value = suggestion.lat.toFixed(6);
    longitude.value = suggestion.lon.toFixed(6);
    locationsData.value = [];
  };
  
  function handleCenterChange(center: { lat: number; lng: number; }) {
    latitude.value = center.lat.toFixed(6);
    longitude.value = center.lng.toFixed(6);
    getAddress(center.lat, center.lng);
  }
  
  const useCurrentLocation = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude: lat, longitude: lng } = position.coords;
        latitude.value = lat.toFixed(6);
        longitude.value = lng.toFixed(6);
      }, (error) => {
        console.error('Error getting current location:', error);
      });
    } else {
      alert('Geolokalizacja nie jest obsługiwana w tej przeglądarce.');
    }
  };
  
  const generateName = async () => {
    deviceName.value = await useDeviceStore().getDeviceName();
  };
  
  const stopQrScan = () => {
    if (scannerInterval.value) {
      window.clearInterval(scannerInterval.value);
      scannerInterval.value = null;
    }
    if (mediaStream.value) {
      mediaStream.value.getTracks().forEach((track) => track.stop());
      mediaStream.value = null;
    }
    if (videoRef.value) {
      videoRef.value.pause();
      videoRef.value.srcObject = null;
    }
    scanActive.value = false;
  };
  
  const startQrScan = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      scanError.value = 'Twoja przeglądarka nie obsługuje skanowania QR.';
      return;
    }

    scanError.value = '';
    scannedValue.value = '';
    scanActive.value = true;

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
      mediaStream.value = stream;

      if (videoRef.value) {
        videoRef.value.srcObject = stream;
        await videoRef.value.play();
      }

      if (typeof (window as any).BarcodeDetector === 'undefined') {
        scanError.value = 'Przeglądarka nie obsługuje API BarcodeDetector.';
        return;
      }

      const detector = new (window as any).BarcodeDetector({ formats: ['qr_code'] });

      scannerInterval.value = window.setInterval(async () => {
        if (!videoRef.value || videoRef.value.readyState !== HTMLMediaElement.HAVE_ENOUGH_DATA) return;

        try {
          const results = await detector.detect(videoRef.value);
          if (results.length > 0) {
            const code = results[0].rawValue || results[0].displayValue;
            if (code) {
              setDeviceNameFromScan(String(code));
              stopQrScan();
            }
          }
        } catch (error) {
          console.warn('Błąd skanowania QR:', error);
        }
      }, 500);
    } catch (error) {
      scanError.value = 'Nie udało się uruchomić kamery. Sprawdź uprawnienia.';
      console.error(error);
      stopQrScan();
    }
  };
  
  const toggleScanner = () => {
    if (scanActive.value) {
      stopQrScan();
    } else {
      startQrScan();
    }
  };
  
  const handleSubmit = async () => {
    if (!deviceName.value) {
      toast.error({ title: 'Błąd!', message: 'Nazwa urządzenia jest wymagana.', position:'topCenter' });
      return;
    }
    if (!latitude.value || !longitude.value) {
      toast.error({ title: 'Błąd!', message: 'Ustaw poprawne współrzędne GPS urządzenia lub wpisz adres.', position:'topCenter' });
      return;
    }

    isSubmitting.value = true;

    try {
      const deviceData = {
        name: deviceName.value,
        location: address.value,
        latitude: parseFloat(latitude.value),
        longitude: parseFloat(longitude.value),
      } as Device;

      await useDeviceStore().addDevice(deviceData);
      toast.success({ title: 'Urządzenie dodane', message: 'Za chwilę nastąpi przekierowanie do strony głównej.', position:'topCenter' });
      window.location.href = '/';
    } catch (error) {
      console.error('Error adding device:', error);
      toast.error({ title: 'Błąd', message: 'Wystąpił błąd podczas dodawania urządzenia. Spróbuj ponownie.', position:'topCenter' });
    } finally {
      isSubmitting.value = false;
    }
  };
  
  onMounted(() => {
    useCurrentLocation();
    generateName();
  });
  
  onUnmounted(() => {
    stopQrScan();
  });
  </script>

  <style>
  
  </style>